import React, { useState } from 'react';
import { ExamsResolutionAnswerKey } from '../exams-resolution/exams-resolution-answer-key';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Sheet, SheetBody, SheetContent } from '@/components/ui/sheet';

export function ExamsMetricsUserItem(props) {
  const { t } = useTranslation();
  const { examStudent } = props;
  const [showModal, setShowModal] = useState(false);

  const userAttempts = examStudent.question_book['question-books-users'][0];
  const currentTime = Date.now();
  const finishDateMillis = new Date(examStudent.question_book['finished-at']).getTime();
  const isInAnalysis = currentTime < finishDateMillis;
  const isApproved = userAttempts?.status === 'approved';
  const isDisapproved = userAttempts?.status === 'disapproved' && examStudent?.question_book?.visibility !== 'open';
  const isExam = examStudent?.question_book?.visibility === 'exam';

  return (
    <>
      <TableRow>
        <TableCell>
          <b>{examStudent?.question_book?.title}</b>{' '}
          <Badge
            size="xm"
            variant="bright"
            square
            className="align-middle font-light"
          >
            {isExam ? 'Prova' : 'Simulado'}
          </Badge>
        </TableCell>
        <TableCell>
          {isInAnalysis ? (
            <Badge
              size="xs"
              variant="warning"
            >
              {t('exams.statusInAnalysis')}
            </Badge>
          ) : isApproved ? (
            <Badge
              size="xs"
              variant="success"
            >
              {isExam ? t('exams.statusInApproved') : 'Corrigido'}
            </Badge>
          ) : isDisapproved ? (
            <Badge
              size="xs"
              variant="danger"
            >
              {t('exams.statusInDisapproved')}
            </Badge>
          ) : null}
        </TableCell>

        <TableCell>{moment(userAttempts['finished-at']).format(t('datesForm.formatDate'))}</TableCell>

        {isInAnalysis ? <TableCell /> : <TableCell>{parseFloat(userAttempts.score).toFixed(2)}</TableCell>}

        <TableCell>
          <Button
            variant="outline"
            size="sm"
            wide
            onClick={() => setShowModal(true)}
            disabled={isInAnalysis}
          >
            {t('button.answerKey')}
          </Button>
        </TableCell>
      </TableRow>

      <Sheet
        open={showModal}
        onOpenChange={setShowModal}
      >
        <SheetContent size="md">
          <SheetBody className="pb-6 pt-12">
            <ExamsResolutionAnswerKey
              examId={examStudent.question_book.id}
              amountQuestions={examStudent.question_book['question-count']}
            />
          </SheetBody>
        </SheetContent>
      </Sheet>
    </>
  );
}
